import React, { useRef, useState } from 'react';
import Modal from '../../BaseComponents/Modal';
import './CSVUploadModal.scss';
import FolderIcon from '@mui/icons-material/Folder';

interface CSVUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFileUpload: (file: File) => void;
}

const CSVUploadModal: React.FC<CSVUploadModalProps> = ({
  isOpen,
  onClose,
  onFileUpload
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isDragOver, setIsDragOver] = useState(false);

  const handleFileSelect = (file: File) => {
    const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
    if (file && (file.type === 'text/csv' || fileExtension === '.csv' || fileExtension === '.xlsx')) {
      onFileUpload(file);
    } else {
      alert('Please select a valid CSV or XLSX file');
    }
  };

  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      handleFileSelect(file);
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragOver(false);

    const file = e.dataTransfer.files[0];
    if (file) {
      handleFileSelect(file);
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Import Users from CSV"
      width="800px"
    >
      <div className="csv-upload-modal">
        <div
          className={`upload-area ${isDragOver ? 'drag-over' : ''}`}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onClick={handleClick}
        >
          <div className="upload-icon">
            <FolderIcon style={{ color: "#FFD700", height: "45px", width: "45px" }} />
          </div>
          <div className="upload-text">
            <p className="primary-text">Click to upload CSV or XLSX file</p>
            <p className="secondary-text">or drag and drop your CSV or XLSX file here</p>
          </div>
        </div>

        <input
          ref={fileInputRef}
          type="file"
          accept=".csv,.xlsx"
          onChange={handleFileInputChange}
          style={{ display: 'none' }}
        />
      </div>
    </Modal>
  );
};

export default CSVUploadModal;
